import { styled } from "styled-components";
import { colors } from "../../lib/sharedStyles";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext";

const StyledButton = styled.button<{ $active: boolean; }>`
  width: 40px;
  height: 24px;
  // Todo: Removing !important (more below) requires alterting theme styles.
  border: 2px solid ${colors.fender.grey03} !important;
  border-radius: 14px;
  padding: 0;
  margin: 0 0 0 8px;
  transition: all 250ms ease;

  &:after {
    content: "";
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background: ${colors.fender.grey03};
    transform: translateX(3px);
    transition: all 250ms ease;
  }

  ${({ $active }) => $active && `
    background: ${colors.fender.primaryDark} !important;
    border-color: ${colors.fender.primaryDark} !important;

    &:after {
      transform: translateX(19px);
      background: ${colors.fender.white};
    }
  `}
`;

const PLPCompareToggle = () => {
  const { compareActive, toggleCompare } = useSearchspringPLPContext();
  return <StyledButton $active={compareActive} onClick={toggleCompare} />;
}

export default PLPCompareToggle;